module.exports = __webpack_public_path__ + "img/ep-U.99e28a32.jpg";